import { Box, Typography } from "@mui/material";
import { money, THEME } from "./boardStyles";
import type { ShowMoney } from "./boardTypes";

function Bar({ label, percent, detail, late }: { label: string; percent: number | null; detail: string; late: boolean }) {
  const value = percent ?? 0;
  const color = value >= 100 ? THEME.green : late ? "#FD355A" : THEME.pink;
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "52px 1fr auto", alignItems: "center", gap: "10px" }}>
      <Typography sx={{ fontSize: "14px", opacity: 0.8 }}>{label}</Typography>
      <Box sx={{ height: 6, borderRadius: 6, background: "rgba(255,255,255,0.15)", overflow: "hidden" }}>
        <Box sx={{ width: `${Math.max(2, value)}%`, height: "100%", borderRadius: 6, background: color }} />
      </Box>
      <Typography sx={{ fontSize: "14px", whiteSpace: "nowrap" }}>
        <Box component="span" sx={{ fontWeight: 600, color }}>
          {percent === null ? "—" : `${percent}%`}
        </Box>
        <Box component="span" sx={{ opacity: 0.7 }}> {detail}</Box>
      </Typography>
    </Box>
  );
}

/** Client and crew payment bars (amounts computed by the API). */
export default function MoneyBars({ value }: { value: ShowMoney }) {
  const { client, crew, issues } = value;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
      <Bar
        label="Client"
        percent={client.finalInvoiceSent ? client.percent : null}
        detail={client.finalInvoiceSent ? `${money(client.due)} left` : "no final invoice"}
        late={issues.includes("clientOverdue") || issues.includes("invoiceNotSent")}
      />
      <Bar
        label="Crew"
        percent={crew.people ? crew.percent : null}
        detail={crew.people ? `${crew.paidPeople}/${crew.people} paid` : "no crew"}
        late={issues.includes("crewOverdue") || issues.includes("posMissing")}
      />
    </Box>
  );
}
